import type { NwssSignalSample } from "./nwssSampleTypes"

/** Split a comma-separated county field for grouping keys only. */
const splitCountyField = (value: string): string[] =>
  value.includes(",") ? value.split(",").filter(part => part !== "") : [value]

/** County keys for heatmaps (comma-split only; values otherwise unchanged). */
export const countyKeysForSample = (sample: NwssSignalSample): string[] => {
  if (sample.counties_served != null && sample.counties_served !== "") {
    return [...new Set(splitCountyField(sample.counties_served))]
  }
  if (sample.county_fips) {
    return [...new Set(splitCountyField(sample.county_fips))]
  }
  return []
}

const normalizeCountyLabel = (value: string): string =>
  value
    .trim()
    .toLowerCase()
    .replace(/\s+county\s*$/i, "")

/** Whether a sample county token matches a reporting county name from the grid. */
export const countyLabelsMatch = (
  sampleCounty: string,
  reporting: string
): boolean =>
  normalizeCountyLabel(sampleCounty) === normalizeCountyLabel(reporting)

/** Reporting county names from ``nwss_meta.counties`` that apply to a sample. */
export const reportingCountiesForSample = (
  sample: NwssSignalSample,
  reportingCounties: string[]
): string[] =>
  reportingCounties.filter(reporting =>
    countyKeysForSample(sample).some(sampleCounty =>
      countyLabelsMatch(sampleCounty, reporting)
    )
  )
